export default "__VITE_ASSET__CRpRRT5K__"